import { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ProductImages } from '../../../Types/OrderDetail';
import './Carousel.css';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

interface Props {
    items: ProductImages[];
}

const ImageCarousel = ({ items }: Props) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
    });

    const [selectedIndex, setSelectedIndex] = useState(0);

    const scrollPrev = useCallback(() => {
        emblaApi?.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        emblaApi?.scrollNext();
    }, [emblaApi]);

    const scrollTo = useCallback(
        (index: number) => emblaApi?.scrollTo(index),
        [emblaApi]
    );

    useEffect(() => {
        if (!emblaApi) return;

        const onSelect = () => {
            setSelectedIndex(emblaApi.selectedScrollSnap());
        };

        onSelect();
        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('select', onSelect);
        };
    }, [emblaApi]);

    return (
        <div className="product-carousel">
            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                    {items.map((image, index) => (
                        <div className="embla__slide" key={index}>
                            <img
                                src={image.PHOTO}
                                alt={`Product ${index + 1}`}
                                className="embla__image"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {items.length > 1 && (
                <>
                    <button
                        className="carousel-button prev"
                        onClick={scrollPrev}
                    >
                        <ChevronLeft fontSize='large' />
                    </button>

                    <button
                        className="carousel-button next"
                        onClick={scrollNext}
                    >
                        <ChevronRight fontSize='large' />
                    </button>

                    <div className="carousel-dots">
                        {items.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => scrollTo(index)}
                                className={
                                    index === selectedIndex
                                        ? 'dot active'
                                        : 'dot'
                                }
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default ImageCarousel;